import React, { ReactElement, useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { ServicesProps } from './Services.types'
import { Button, ButtonSizeTypes, SideRail, Table, TableColumn, TableMetaProps } from '@digicert/dcone-common-ui'
import styles from './Services.module.scss'
import { IAccessScope, IServiceProviderAccount } from '../../../../reducers/Reducers.interfaces';
import { LIMIT_10 } from '../../../../core/utils/constants';
import cn from 'classnames';
import { EditServices } from './edit/EditServices';
import { Translate } from 'react-localize-redux';
import { fetchServicesByAccountId } from './Services.actions'
import { translate } from 'shared/helpers/utils'
import { IAppState } from 'core/store/store'
import { fetchTenantById } from 'secure-pages/tenants/Tenants.actions'

const defaultMeta: TableMetaProps<IServiceProviderAccount> = {
    pageSize: LIMIT_10,
    currentPage: 1,
    totalItems: 0,
    filters: {},
    sort: {
        columnKey: "source_account_name",
        order: "ascend"
    }
}

const Services = (
    {
        account,
        canEdit,
        fetchServicesByAccountId,
        setAccount,
        fetchTenantById
    }: ServicesProps):ReactElement => {
    const [services, setServices] = useState<IServiceProviderAccount[]>()
    const [meta, ] = useState(defaultMeta)
    const [loading, setLoading] = useState(true)
    const [, setCcNewAccount] = useState<string>()
    const [, setDconeNewAccount] = useState<string>()
    const [showSideRail, setShowSideRail] = useState(false)

    const getTableColumns = (): TableColumn<IServiceProviderAccount>[] => [
        {
            key: 'name',
            title: translate('accounts.details.services.accountName') as string,
            sorter: true,
            render: serviceProviderAccount => (
                <>
                    {serviceProviderAccount.show_account_required && <p>{translate('accounts.details.services.accountRequied') as string}</p>}
                    {serviceProviderAccount.show_add_account_link && <a rel="noreferrer" href={serviceProviderAccount.account_url} target='_blank'>{translate('accounts.details.services.addAccount') as string}</a>}
                    {serviceProviderAccount.account_url && serviceProviderAccount.name && <a rel="noreferrer" href={serviceProviderAccount.account_url} target='_blank'>{serviceProviderAccount.name}</a>}
                </>
            )
        },
        {
            key: 'id',
            title: translate('accounts.details.services.accountId') as string,
            sorter: true,
            render: serviceProviderAccount => (
                <>{serviceProviderAccount.id ? serviceProviderAccount.id : '-'}</>
            )
        },
        {
            key: 'enabled_services',
            title: translate('accounts.details.services.enabledServices') as string,
            render: serviceProviderAccount => (
                <>
                    {serviceProviderAccount.enabled_services.map((item) => {
                        return (
                            <div key={item}>{item}</div>
                        )
                    })}
                </>
            )
        }
    ]

    const tableChange = useCallback(
        () => {
            console.log('Waiting on backend to sort')
        },
        []
    )

    useEffect(() => {
        setLoading(false)
        fetchServicesByAccountId(account.id).then(res => {
            setServices(res.service_provider_accounts)
            if (res.certcentral_new_account_linking_url) {
                setCcNewAccount(res.certcentral_new_account_linking_url)
            }
            if (res.dcone_new_account_linking_url) {
                setDconeNewAccount(res.dcone_new_account_linking_url)
            }
        })
    }, []);

    const refresh = (): void => {
        fetchServicesByAccountId(account.id).then(res => {
            setServices(res.service_provider_accounts)})
        fetchTenantById(account.id).then(res => {
            setAccount(res)
        })
        }

    return (
        <section className={styles.services}>
            <header className={styles.header}>
                <div>
                    <h1><Translate id='accounts.details.sideNav.services'/></h1>
                    <p><Translate id='accounts.details.services.enabledServicesMessage'/></p>
                </div>

            {canEdit &&
                <Button size={ButtonSizeTypes.SMALL} onClick={() => setShowSideRail(true)}><Translate id='common.form.buttons.updateServices'/></Button>
            }
            </header>

            {services && services?.length > 0 &&

                <div className={styles.content}>
                    <Table
                        className={styles.table + ' ' +  'resizable-table-body'}
                        columns={getTableColumns()}
                        items={services}
                        getRowKey={account => account.id}
                        meta={meta}
                        onChange={tableChange}
                        disableCheckBoxes
                        loading={loading}
                    />
                </div>

            }

            <SideRail
                className={cn(styles.sideRail, showSideRail && styles.expanded)}
                headline={<h2><Translate id='accounts.details.services.updateServices'/></h2>}
                show={showSideRail}
                onDismiss={() => setShowSideRail(!showSideRail)}
                lightbox
            >
                <div className={styles.sideRailContent}>
                    <EditServices services={account.applications} account={account} onCancel={() => {setShowSideRail(false)}} refresh={refresh}/>
                </div>
            </SideRail>
        </section>
    )
}

export default connect(
    (state: IAppState) => {
        return {
            profile: state.profile.data
        }
    },
    {
        fetchServicesByAccountId, fetchTenantById
    }
)(Services)
